<script setup>
const props = defineProps({
  slots:        { type: Array,  default: () => [] },
  selectedSlot: { type: Object, default: null },
  timeFormat:   { type: String, default: '12_hours' },
})
const emit = defineEmits(['slot-selected', 'slot-confirmed'])

function isSelected(slot) {
  return props.selectedSlot?.utc_minutes?.start_at === slot.utc_minutes?.start_at
}
function selectSlot(slot) { emit('slot-selected', slot) }
function confirmSlot(slot) { emit('slot-confirmed', slot) }
</script>

<template>
  <!-- Empty state -->
  <div v-if="!slots.length"
       class="flex flex-col items-center justify-center py-12 text-center px-4">
    <svg class="w-8 h-8 text-gray-300 dark:text-gray-600 mb-3" fill="none" viewBox="0 0 24 24"
         stroke="currentColor" stroke-width="1.5">
      <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <p class="text-sm text-gray-400 dark:text-gray-500">No available slots</p>
  </div>

  <!-- Slot list — original ring/outline style restored -->
  <div v-else class="space-y-3 text-blue-600 font-semibold text-sm dark:text-gray-400">
    <div v-for="(slot, index) in slots"
         :key="index"
         class="flex gap-1">

      <!-- Slot button -->
      <button type="button"
              @click="selectSlot(slot)"
              :aria-pressed="isSelected(slot)"
              :class="isSelected(slot)
                ? 'bg-neutral-500 text-white border-none w-2/3 sm:text-[13px]'
                : 'ring-1 ring-blue-400 w-full hover:ring-blue-600 hover:ring-2 dark:ring-gray-200 dark:hover:ring-white'"
              class="timelydo-slot-available transition-all flex items-center justify-center
                     duration-400 py-3 text-center rounded dark:border-gray-400">
        <span v-if="slot['12_hours']?.c_avb">
          <svg class="fill-blue-500 w-3 h-3 mr-2 inline" viewBox="0 0 24 24">
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z"/>
          </svg>
        </span>
        {{ slot[timeFormat]?.start_at }} - {{ slot[timeFormat]?.end_at }}
      </button>

      <!-- Confirm button — only visible when this slot is selected -->
      <button v-if="isSelected(slot)"
              type="button"
              @click="confirmSlot(slot)"
              class="timelydo-slot-confirm w-2/5 bg-blue-600 text-white border-none
                     transition-all duration-400 py-3 text-center rounded">
        Confirm
      </button>

    </div>
  </div>
</template>
